import { service } from '@maia/customer';
import { useMutation } from '@tanstack/react-query';

type UseCreateCustomerNoteParams = Parameters<typeof service.createNote>[1];

export function useCreateCustomerNote(
  customerGuid: string,
  onSuccess?: () => void,
  onError?: () => void,
) {
  return useMutation({
    mutationFn: (args: UseCreateCustomerNoteParams) =>
      service.createNote(`customers/${customerGuid}/notes`, args),
    onSuccess,
    onError,
  });
}
